import AnalyticsDetailCard from './DetailCard'
import { AnalyticsDetailCardGrid } from './DetailCard.styled'

export { AnalyticsDetailCardGrid }
export default AnalyticsDetailCard
